import { useState } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { Card, Input, Button, Typography, Space, message } from "antd";
import logo from "../../images/LOGO TROCAENVIO.png";
import { useAuth } from "./AuthContext";
import { loginRequest } from "./api";
import { loginErrorMessage, validateLoginForm } from "./loginErrors";

const { Title } = Typography;

export default function Login() {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/pedidos";

  // Quem já está logado não precisa do formulário: abrir /login pelo histórico ou
  // por um favorito leva direto ao painel.
  if (isAuthenticated) return <Navigate to={from} replace />;

  const handleLogin = async () => {
    if (loading) return;
    const formError = validateLoginForm({ email, senha });
    if (formError) {
      message.warning(formError);
      return;
    }
    setLoading(true);
    try {
      const data = await loginRequest({ email: email.trim(), senha });
      login({ token: data.token, user: data.user });
      navigate(from, { replace: true });
    } catch (err) {
      message.error(loginErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="brand-login">
      <Card className="brand-login__card">
        <img src={logo} alt="Logo TrocaEnvio" className="brand-login__logo" />
        <Title level={3} className="te-page-title" style={{ textAlign: "center", marginBottom: 8 }}>
          Acesse o backoffice
        </Title>
        <p className="brand-login__subtitle">Menos fricção, mais controle da operação.</p>
        <Space direction="vertical" style={{ width: "100%" }} size="middle">
          <Input
            size="large"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input.Password
            size="large"
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            onPressEnter={handleLogin}
          />
          <Button type="primary" size="large" onClick={handleLogin} loading={loading} block>
            Entrar
          </Button>
        </Space>
      </Card>
    </div>
  );
}
